import { useTranslation } from 'react-i18next'
import { Space } from 'antd'

interface DeliveryDateProps {
  deliveryData?: {
    numberOfItems?: number
    deliveryDate?: string
  }[]
}

const DeliveryDate = (props: DeliveryDateProps) => {
  const { deliveryData } = props
  const { t } = useTranslation()

  const translationKey = Array.isArray(deliveryData) && deliveryData.length > 1
    ? 'estimatedDeliveryDateWithNumber'
    : 'estimatedDeliveryDate'

  return (
    <Space className="cart-item-name__delivery-date" direction="vertical">
      {deliveryData?.map((data) => {
        return (
          <span
            key={`${data.numberOfItems}-${data.deliveryDate}`}
            style={{ display: 'block' }}
          >
            {t(`cart.table.${translationKey}`, {
              count: data.numberOfItems,
              deliveryDate: data.deliveryDate,
            })}
          </span>
        )
      })}
    </Space>
  )
}

export default DeliveryDate
